module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-edit"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.edit')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.name')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nedit",
      "placeholder": "*"
    },
    domProps: {
      "value": _vm.deviceName
    },
    on: {
      "input": _vm.updateDeviceName,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editDevice(_vm.id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.comment')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cedit",
      "placeholder": "*"
    },
    domProps: {
      "value": _vm.deviceComment
    },
    on: {
      "input": _vm.updateDeviceComment,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editDevice(_vm.id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.group')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "taggable": "",
      "options": _vm.groups,
      "placeholder": "*"
    },
    on: {
      "search:focus": _vm.getGroups
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveNoEdit')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editDevice(_vm.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveYesEdit')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.listOfAllDevices')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('div', {
    staticClass: "input-group input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchallDevices),
      expression: "searchallDevices"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": _vm.$t('pages.adminpanel.tablets.search')
    },
    domProps: {
      "value": (_vm.searchallDevices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchallDevices = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getAllDevices(_vm.searchallDevices)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.identifier')) + "\n              "), (_vm.sortByAll == 'identifier') ? _c('span', [(_vm.sortOrderAll == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrderAll == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ca('sortBy', 'identifier');
        _vm.ca('sortOrder', _vm.sortOrderAfterInitialClickAll)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.deviceName')) + "\n              "), (_vm.sortByAll == 'name') ? _c('span', [(_vm.sortOrderAll == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrderAll == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ca('sortBy', 'name');
        _vm.ca('sortOrder', _vm.sortOrderAfterInitialClickAll)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.updated')) + "\n              "), (_vm.sortByAll == 'updatedAt') ? _c('span', [(_vm.sortOrderAll == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrderAll == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ca('sortBy', 'updatedAt');
        _vm.ca('sortOrder', _vm.sortOrderAfterInitialClickAll)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.group')) + "\n              "), (_vm.sortByAll == 'group') ? _c('span', [(_vm.sortOrderAll == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrderAll == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ca('sortBy', 'group');
        _vm.ca('sortOrder', _vm.sortOrderAfterInitialClickAll)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.comment')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.registered')) + "\n              "), (_vm.sortByAll == 'registered') ? _c('span', [(_vm.sortOrderAll == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrderAll == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ca('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ca('sortBy', 'registered');
        _vm.ca('sortOrder', _vm.sortOrderAfterInitialClickAll)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])])]), _vm._v(" "), _vm._l((_vm.allDevices), function(dev) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dev.identifier))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "id": "buttonPoiner"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleModalForEdit(dev)
        }
      }
    }, [_vm._v(_vm._s(dev.name))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.getDate(dev.updatedAt)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dev.group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dev.comment))]), _vm._v(" "), _c('td', [(dev.isRegistered) ? _c('span', [_c('div', {
      staticClass: "badge bg-blue"
    }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.registered')))])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.alertForUpdateSecret(dev)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.generateOtp')) + "\n              ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "id": "buttonPoiner"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleModalForDeletion(dev)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.listOfAnnouncedDevices')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('div', {
    staticClass: "input-group input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchannouncedDevices),
      expression: "searchannouncedDevices"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": _vm.$t('pages.adminpanel.tablets.search')
    },
    domProps: {
      "value": (_vm.searchannouncedDevices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchannouncedDevices = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getAnnDevices(_vm.searchannouncedDevices)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.identifier')) + "\n              "), (_vm.sortBy == 'identifier') ? _c('span', [(_vm.sortOrder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cm('sortBy', 'identifier');
        _vm.cm('sortOrder', _vm.sortOrderAfterInitialClick)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.deviceName')) + "\n              "), (_vm.sortBy == 'name') ? _c('span', [(_vm.sortOrder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cm('sortBy', 'name');
        _vm.cm('sortOrder', _vm.sortOrderAfterInitialClick)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.updated')) + "\n              "), (_vm.sortBy == 'updatedAt') ? _c('span', [(_vm.sortOrder == 'desc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.sortOrder == 'asc') ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cm('sortOrder', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })]) : _vm._e()]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cm('sortBy', 'updatedAt');
        _vm.cm('sortOrder', _vm.sortOrderAfterInitialClick)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  })])])])]), _vm._v(" "), _vm._l((_vm.announcedDevices), function(dev) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dev.identifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dev.name))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.getDate(dev.updatedAt)) + "\n            ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleModalForRegistration(dev)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.register')) + "\n              ")])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-register"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.register')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.confirm) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.name')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nreg",
      "placeholder": "*"
    },
    domProps: {
      "value": _vm.deviceName
    },
    on: {
      "input": _vm.updateDeviceName
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.confirm) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.comment')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "creg",
      "placeholder": "*"
    },
    domProps: {
      "value": _vm.deviceComment
    },
    on: {
      "input": _vm.updateDeviceComment
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.confirm) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.group')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "taggable": "",
      "options": _vm.groups,
      "placeholder": "*"
    },
    on: {
      "search:focus": _vm.getGroups
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.password')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "",
      "placeholder": "Please enter your user password"
    },
    domProps: {
      "value": _vm.devicePassword
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.dismissModalForRegistration()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.approveDevice(_vm.identifier)
      }],
      "input": _vm.updateDevicePassword
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.confirm) ? _c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmToggle()
      }
    }
  }, [_vm._v("Back")]) : _c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.modalToggle()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveNo')))]), _vm._v(" "), (!_vm.confirm && _vm.deviceComment && _vm.selectedGroup) ? _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmToggle()
      }
    }
  }, [_vm._v("Continue")]) : (_vm.confirm) ? _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.approveDevice(_vm.identifier)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveYes')))]) : _c('button', {
    staticClass: "btn btn-outline disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Continue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-danger fade",
    attrs: {
      "id": "modal-delete"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.delete')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.password')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "",
      "placeholder": "Please enter your user password"
    },
    domProps: {
      "value": _vm.devicePassword
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.deleteDevice(_vm.id)
      },
      "input": _vm.updateDevicePassword
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveNo')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteDevice(_vm.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalDeleteYes')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-primary fade",
    attrs: {
      "id": "modal-update"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.generateOtp')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.password')))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pdel",
      "placeholder": "Please enter your user password"
    },
    domProps: {
      "value": _vm.devicePassword
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.generateDevice(_vm.id)
      },
      "input": _vm.updateDevicePassword
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalApproveNo')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generateDevice(_vm.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.tablets.modalDeleteYes')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c7b0ab6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7b0ab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Tablets.vue
// module id = 1425
// module chunks = 1